// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat

import { Currency } from '../Types/BookitupDocument';
import { Country } from './ContactS';

// Output: 100,00 EUR
const CurrencyFormatter = new Intl.NumberFormat('de-DE', {
  style: 'currency',
  currency: 'EUR',
  currencyDisplay: 'code',
});

// Output: 100,00 €
const CurrencyFormatterWithEuroSign = new Intl.NumberFormat('de-DE', {
  style: 'currency',
  currency: 'EUR',
});

// Output: CHF 100.00
const CurrencyFormatterWithFrancSign = new Intl.NumberFormat('de-CH', {
  style: 'currency',
  currency: 'CHF',
});

const formatCurrency = (price: string): string => CurrencyFormatter.format(parseFloat(price));

const formatNumberCurrencyWithUnitSign = (value: number): string => formatCurrencyWithUnitSign(value.toString());

const formatCurrencyWithUnitSign = (price: string): string => {
  if (Number.isNaN(parseFloat(price))) {
    return ' - €';
  }
  return CurrencyFormatterWithEuroSign.format(parseFloat(price));
};

const numberToCurrency = (num: number | null | undefined) => {
  if (num === null || num === undefined || Number.isNaN(num)) {
    return ' - €';
  }
  return formatCurrencyWithUnitSign(num.toString());
};

const formatAsCurrency = (val: string) => {
  const intVal = parseFloat(val.replace(',', '.'));
  return isNaN(intVal) ? 0 : intVal;
};

const formatPriceWithCountry = (country: Country, price = 0) => {
  if (country === 'CH') {
    return CurrencyFormatterWithFrancSign.format(price);
  }
  return CurrencyFormatterWithEuroSign.format(price);
};

const formatPriceWithCurrency = (currency: Currency, price = 0) => {
  if (currency === 'EUR') {
    return CurrencyFormatterWithEuroSign.format(price);
  }
  return CurrencyFormatterWithFrancSign.format(price);
};

const getCountryCurrencySymbol = (country: Country) => {
  if (country === 'CH') {
    return 'CHF';
  }
  return '€';
};

// eslint-disable-next-line import/prefer-default-export
export const FormatS = {
  formatCurrency,
  formatCurrencyWithUnitSign,
  numberToCurrency,
  formatNumberCurrencyWithUnitSign,
  formatAsCurrency,
  formatPriceWithCountry,
  formatPriceWithCurrency,
  getCountryCurrencySymbol,
};
